module.exports = __webpack_public_path__ + "static/media/lock-dynamic-premium.7839c0fe.png";